import * as React from "react";
import PropTypes from "prop-types";
const SvgAchievementsTrophyNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#achievements_trophy_normal_large_svg__clip0_138_112)">
        <path
          d="M26.41 41.5h-4.74l-8.59 4.58V48H35v-1.92l-8.59-4.58zM17.48 46l6.49-3.46h.14L30.6 46H17.48zM40 3V0H8v3H-.05v7c0 1.88.17 3.68 2.2 5.07.69.47 2.24 1.33 3.85 2.2V15c-1.19-.65-2.22-1.24-2.72-1.58-1.24-.85-1.33-1.86-1.33-3.42V5H8v15a11.425 11.425 0 005.21 8.97l9.79 5.6v4.93h2v-4.93l9.79-5.6A11.426 11.426 0 0040 20V5h5.95v5c0 1.56-.08 2.57-1.32 3.42-.49.33-1.48.9-2.63 1.53v2.27c1.58-.85 3.09-1.69 3.76-2.15 2.03-1.39 2.19-3.19 2.19-5.07V3H40zm-2 17a9.502 9.502 0 01-4.2 7.24l-9.73 5.55h-.14l-9.73-5.55A9.5 9.5 0 0110 20V2h28v18z"
          fill=""
        />
      </g>
      <defs>
        <clipPath id="achievements_trophy_normal_large_svg__clip0_138_112">
          <path fill="#fff" d="M0 0h48v48H0z" />
        </clipPath>
      </defs>
    </svg>
  )
);
SvgAchievementsTrophyNormalLarge.defaultProps = {
  color: "currentColor",
  size: 48,
  title: undefined,
  titleId: undefined,
};
SvgAchievementsTrophyNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgAchievementsTrophyNormalLarge;
